<template>
  <div class="ub">
    <label v-if="label" class="ub-label">{{ label }}</label>
    <div v-if="helper" class="ub-helper">{{ helper }}</div>

    <div class="ub-row">
      <input
        ref="fileInput"
        type="file"
        class="ub-file"
        :disabled="disabled"
        :accept="accept"
        @change="pick"
      />

      <button
        v-if="name"
        class="ub-btn ub-btn--soft"
        type="button"
        :disabled="disabled"
        @click="clear"
        title="Clear selected file"
      >
        Clear
      </button>
    </div>

    <div v-if="name" class="ub-meta">
      <span class="ub-pill">{{ name }}</span>
      <span class="ub-pill">{{ prettyBytes(size) }}</span>
      <span v-if="mimeType" class="ub-pill">{{ mimeType }}</span>
    </div>

    <div v-else-if="disabled && disabledHint" class="ub-helper ub-helper--danger">
      {{ disabledHint }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'UploadBox',
  props: {
    label: { type: String, default: '' },
    helper: { type: String, default: '' },

    disabled: { type: Boolean, default: false },
    disabledHint: { type: String, default: '' },

    accept: { type: String, default: 'application/pdf,image/*' },
    maxSizeMB: { type: Number, default: 20 }
  },
  data () {
    return {
      name: '',
      size: 0,
      mimeType: ''
    }
  },
  methods: {
    prettyBytes (n) {
      try {
        n = Number(n || 0)
        if (!n) return '0 B'
        const units = ['B', 'KB', 'MB', 'GB']
        let u = 0
        while (n >= 1024 && u < units.length - 1) { n = n / 1024; u++ }
        return (Math.round(n * 10) / 10) + ' ' + units[u]
      } catch (e) {
        return String(n || 0)
      }
    },

    clear () {
      this.name = ''
      this.size = 0
      this.mimeType = ''
      try { this.$refs.fileInput.value = '' } catch (e) {}
      this.$emit('cleared')
    },

    pick (e) {
      if (this.disabled) return

      const f = (e && e.target && e.target.files && e.target.files[0]) ? e.target.files[0] : null
      if (!f) return

      const max = Number(this.maxSizeMB || 0) * 1024 * 1024
      if (max > 0 && f.size > max) {
        this.$emit('error', `File too large (>${this.maxSizeMB} MB).`)
        try { e.target.value = '' } catch (ex) {}
        return
      }

      const rdr = new FileReader()
      rdr.onload = () => {
        this.name = f.name
        this.size = f.size || 0
        this.mimeType = f.type || ''

        // New single clean event for the new backend API
        this.$emit('picked', {
          filename: f.name,
          mimeType: f.type || '',
          byteSize: f.size || 0,
          dataUrl: rdr.result
        })
      }
      rdr.onerror = () => {
        this.$emit('error', 'Failed to read file.')
      }
      rdr.readAsDataURL(f)
    }
  }
}
</script>

<style scoped>
.ub { display:flex; flex-direction:column; gap:6px; }
.ub-label { font-size:12px; opacity:.8; font-weight:700; }
.ub-helper { font-size:12px; opacity:.75; }
.ub-helper--danger { color:#b91c1c; opacity:1; }

.ub-row { display:flex; gap:10px; align-items:center; flex-wrap:wrap; }
.ub-file { font-size:13px; }
.ub-btn { border:1px solid rgba(0,0,0,.12); background:#fff; padding:8px 10px; border-radius:10px; cursor:pointer; font-size:13px; }
.ub-btn:disabled { opacity:.55; cursor:not-allowed; }
.ub-btn--soft { background: rgba(0,0,0,.03); }

.ub-meta { display:flex; gap:8px; flex-wrap:wrap; margin-top:4px; }
.ub-pill { font-size:12px; background: rgba(0,0,0,.05); padding:4px 8px; border-radius:999px; }
</style>
